import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentUpiComponent } from './payment-upi.component';
import { PaymentSipUpiModule } from '../payment-sip-upi/payment-sip-upi.module';
import { PaymentMethodListModule } from '../payment-method-list/payment-method-list.module';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { PaymentSipButtonModule } from '../payment-sip-button/payment-sip-button.module';
import { MatIconModule } from '@angular/material/icon';
import { QrcodeBoxModule } from '../qrcode-box/qrcode-box.module';



@NgModule({
  declarations: [
    PaymentUpiComponent
  ],
  exports: [
    PaymentUpiComponent
  ],
  imports: [
    CommonModule,
    PaymentSipUpiModule,
    PaymentMethodListModule,
    MatRadioModule,
    FormsModule,
    PaymentSipButtonModule,
    MatIconModule,
    QrcodeBoxModule
  ]
})
export class PaymentUpiModule { }
